import { breakpoints } from '@/src/utils/mediaQuery';
import { Icon } from '@ovotech/element-v4';
import { Strong } from '@ovotech/nebula';
import styled from 'styled-components';

export const StyledPredictableBalanceWrapper = styled.div`
  display: grid;
  grid-template-columns: 75% 3fr 1fr;
  padding-right: 0;

  @media ${breakpoints.smallDown} {
    grid-template-columns: 55% 3fr 1fr;
  }
`;

export const StyledIcon = styled(Icon)`
  margin-top: 4px;
`;

export const StyledAdvicePanelFigures = styled(Strong)`
  padding-right: 3rem;
  text-align: right;
  white-space: nowrap;
  align-content: end;
  margin-bottom: 1.2rem;
`;

export const StyledBr = styled.br`
  display: none;

  @media ${breakpoints.smallDown} {
    display: inline;
  }

  @media (max-width: 370px) {
    display: none;
  }
`;
